import {useTrackingRef} from './use-tracking-ref'

export function usePreviousValue<T>(value: T): T {
  return useTrackingRef(value).current
}
